import React, { useState } from 'react';
import { Star } from 'lucide-react';
import { Button } from './ui/button';
import { toast } from 'sonner';
import { apiClient } from '../api';

const SuperLikeButton = ({ targetUserId, targetName }) => {
  const [busy, setBusy] = useState(false);

  const handle = async () => {
    setBusy(true);
    try {
      await apiClient.post(`/super-likes/${targetUserId}`);
      toast.success('Super-liked!', {
        description: `${targetName || 'They'}'ll see it in their messages.`,
      });
    } catch (err) {
      const detail = err.response?.data?.detail || '';
      if (err.response?.status === 429) {
        toast('On cooldown', { description: 'You can super-like again later.' });
      } else {
        toast.error('Super-like failed', { description: detail });
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      onClick={handle}
      disabled={busy}
      variant="outline"
      className="bg-fnl-purple-light/40 border-yellow-400/60 text-yellow-300 hover:bg-yellow-500/15 hover:text-yellow-200"
      data-testid="super-like-btn"
      title="Send a super-like"
    >
      <Star className="w-4 h-4 mr-1.5 fill-yellow-300" />
      Super-like
    </Button>
  );
};

export default SuperLikeButton;
